import SmartStatItem from './SmartStatItem.vue';

export default SmartStatItem;



// WEBPACK FOOTER //
// ./src/pages/profile/blocks/children/sidebar/components/childrenlist/child/components/smart/components/item/index.ts